import { Icon } from '@chakra-ui/react';

export default function SFExclamationMarkCircleFilled(props) {
  return (
    <Icon
      width='9'
      height='8'
      viewBox='0 0 9 8'
      fill='currentColor'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <g clipPath='url(#clip0_2283_192851)'>
        <rect
          x='0.875'
          width='7.9375'
          height='7.9375'
          rx='3.96875'
          fill='none'
        />
        <path
          d='M4.84375 7.9375C2.67188 7.9375 0.875 6.15625 0.875 3.96875C0.875 1.79688 2.67188 0 4.84375 0C7.02344 0 8.8125 1.78906 8.8125 3.96875C8.8125 6.14062 7 7.9375 4.84375 7.9375ZM4.84375 4.64062C5.11719 4.64062 5.3125 4.45312 5.32031 4.1875L5.38281 1.95312C5.39062 1.63281 5.17188 1.41406 4.84375 1.41406C4.51562 1.41406 4.30469 1.63281 4.3125 1.95312L4.375 4.1875C4.38281 4.45312 4.57031 4.64062 4.84375 4.64062ZM4.84375 6.5C5.21094 6.5 5.5 6.21094 5.50781 5.84375C5.50781 5.48438 5.21094 5.17969 4.84375 5.17969C4.48438 5.17969 4.1875 5.48438 4.1875 5.84375C4.1875 6.21094 4.48438 6.5 4.84375 6.5Z'
          fill='currentColor'
        />
      </g>
      <defs>
        <clipPath id='clip0_2283_192851'>
          <rect
            x='0.875'
            width='7.9375'
            height='7.9375'
            rx='3.96875'
            fill='none'
          />
        </clipPath>
      </defs>
    </Icon>
  );
}
